import SetService from "../../Services/Shared/Set.service";
const setToTrails = ({ id, type, children, }) => {
    if (Array.isArray(children)) {
        const childrenArray = children;
        return childrenArray
            .flatMap((child) => {
            return setToTrails(child);
        })
            .map((trail) => ({ id, type, child: trail }));
    }
    return [{ id, type, child: children }];
};
const getSchedulableFromTrail = (trail) => // $FlowFixMe - if the child of this trail has a child, it is a schedulable.
 
// @ts-expect-error - TS2322 - Type 'Schedulable | SchedulableTrail' is not assignable to type 'Schedulable'. | TS2339 - Property 'child' does not exist on type 'Schedulable | SchedulableTrail'. | TS2345 - Argument of type 'Schedulable | SchedulableTrail' is not assignable to parameter of type 'SchedulableTrail'.
trail.child.child ? getSchedulableFromTrail(trail.child) : trail.child;
export default class SchedulableService {
    static getDaysSet(sec) {
        // @ts-expect-error - TS2322 - Type 'Set<unknown>' is not assignable to type 'Set<"sunday" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday">'.
        return sec.elms.reduce((sum, elm) => {
            const set = new Set();
            if (elm.sunday) {
                set.add("sunday");
            }
            if (elm.monday) {
                set.add("monday");
            }
            if (elm.tuesday) {
                set.add("tuesday");
            }
            if (elm.wednesday) {
                set.add("wednesday");
            }
            if (elm.thursday) {
                set.add("thursday");
            }
            if (elm.friday) {
                set.add("friday");
            }
            if (elm.saturday) {
                set.add("saturday");
            }
            return SetService.union(sum, set);
        }, new Set());
    }
    static getSchedulableFromTrail(trail) {
        // @ts-expect-error - TS2322 - Type 'Schedulable | SchedulableTrail' is not assignable to type 'Schedulable'. | TS2339 - Property 'child' does not exist on type 'Schedulable | SchedulableTrail'.
        return trail.child.child
            ? // $FlowFixMe - if the child of this trail has a child, it is a schedulable.
                // @ts-expect-error - TS2345 - Argument of type 'Schedulable | SchedulableTrail' is not assignable to parameter of type 'SchedulableTrail'.
                SchedulableService.getSchedulableFromTrail(trail.child)
            : trail.child;
    }
    static hasConflict(secA, secB, bufferMinutes = 0) {
        let first = secA;
        let second = secB;
        let overlapDays;
        if (secA.startDate && secA.endDate && secB.startDate && secB.endDate) {
            // Order the dates
            const sorted = [secA, secB].sort((a, b) => 
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2533 - Object is possibly 'null' or 'undefined'.
            a.startDate > b.startDate ? 1 : -1);
            first = sorted[0];
            second = sorted[1];
            // Make sure that these course sections overlap.
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2533 - Object is possibly 'null' or 'undefined'.
            if (first.endDate < second.startDate) {
                return false;
            }
            // Find the days of the week these sections have in common.
            const overlapTime = Math.max(
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            first.endDate.getMilliseconds(), 
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            second.endDate.getMilliseconds()) - second.startDate.getMilliseconds();
            // If the overlap is more than a week, just figure out what days these
            // course sections have in common
            if (overlapTime >= 1000 * 60 * 60 * 24 * 7) {
                overlapDays = SetService.union(SchedulableService.getDaysSet(first), SchedulableService.getDaysSet(second));
            }
            else {
                // TODO need to examine the overlap and figure out which days of the week exist in it.
                // for now, we just still consider every day.
                overlapDays = SetService.union(SchedulableService.getDaysSet(first), SchedulableService.getDaysSet(second));
            }
        }
        else {
            overlapDays = SetService.union(SchedulableService.getDaysSet(first), SchedulableService.getDaysSet(second));
        }
        const firstDays = {};
        const secondDays = {};
        for (const day of overlapDays) {
            firstDays[day] = first.elms.reduce((sum, elm) => elm[day]
                ? [
                    ...sum,
                    {
                        start: elm.startTimeHours24 + elm.startTimeMinutes24 / 60,
                        end: elm.endTimeHours24 + elm.startTimeMinutes24 / 60,
                    },
                ]
                : sum, []);
            secondDays[day] = second.elms.reduce((sum, elm) => elm[day]
                ? [
                    ...sum,
                    {
                        start: elm.startTimeHours24 + elm.startTimeMinutes24 / 60,
                        end: elm.endTimeHours24 + elm.startTimeMinutes24 / 60,
                    },
                ]
                : sum, []);
        }
        for (const day of overlapDays) {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            for (const firstInterval of firstDays[day]) {
                // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                for (const secondInterval of secondDays[day]) {
                    const ordered = [firstInterval, secondInterval].sort((a, b) => a.start - b.start);
                    if (ordered[0].end + bufferMinutes / 60 > ordered[1].start) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    static hasConflictArray(secA, secs, bufferMinutes = 0) {
        return secs.some((sec) => SchedulableService.hasConflict(secA, sec, bufferMinutes));
    }
    // TODO - make this work for the case when you have three course groups which all have a shared course section that is selected
    /* Tough problem.  Here's how I think we should solve it -- When course groups are ambiguous (a course section they have
     * is selected, but is part of another course group) we should group them into another kind of scheduler set.  So,
     * we'll have groups of course groups.  Currently, this works for only two course groups.  What happens when three (or more)
     * course groups all share a selected course section?  We need to tell this algorithm to select more than one item
     * from a particular set (in this case, two items).  An attribute needs to be added to SchedulerSet that indicates how many items from that
     * set should be scheduled.  Then, when the algorithm below finds that it needs to schedule more than one item in the
     * set, it generates a schedule with just one item for the set, then it figures out which of the top level items have been fulfilled.
     * To  do this efficiently, a change needs to be made to schedulableTrails where we record the id of every parent of an item
     * and not just the path that we decided to go down.  Id and type will become a grouped array {id, type}[].
     * Next, we restructure our list of sets according to what was scheduled.  We may be able to take a course group out of a grouping, or
     * we may find, especially for larger groups of groups, that the group is somehow split up into two smaller groups.  We then
     * recurse on this smaller problem.
     */
    /**
     * Generate possible schedules which include a list of schedulables.
     *
     * @param {SchedulableTrail[]} selected -
     * A list of schedulableTrails that are currently selected.  These schedulables must be included
     * in all generated schedules.
     *
     *
     * @param {SchedulableSet[]} sets -
     * A list of schedulable sets that we need to schedule.
     * In this case a schedulable set is a grouping of schedulables any of which can be scheduled to fulfill the group
     * For example, there could be a set of type `course`, which has sets of type `course_section`.  We only need
     * to schedule one course section.
     * Similarly, there could be a set of type `course_group`, which has sets of type `course`, which has sets of type `course_section`.
     * In this case, we only need to schedule one `course_section` from this group.  There could also be a set of type `break` which would have no
     * children sets and could be considered just a list of schedulables.
     *
     * @returns {SchedulableTrail[][]}
     * A list of possible schedules where each schedule is represented by a list of schedulableTrails.
     *
     */
    static generateSchedule(selected, sets) {
        // If there are no groups, then there exists one valid schedule -- the empty schedule.
        // This serves as our base case when we recurse.
        if (!sets.length) {
            return [[]];
        }
        return (
        // First, we convert the the first set to an array of trails.
        setToTrails(sets[0]).flatMap((trail) => {
            /*
            For each trail we're going to see if there's a conflict with what's currently selected and the trail.
            If there's not, we're going to generate schedules for the sets besides the first one, and this trail included
            in selected.  Once we have schedules that work with this trail, we add the trail to each schedule by mapping all of the schedules
            to also include the current trail
    
            By the end of all this we have an array of schedules that work for each trail.  Instead, we want a long list of schedules,
            so we combine all of these lists by flatMapping.
            */
            // Check to see if there's a conflict with this trail and what's selected
            if (!this.hasConflictArray(SchedulableService.getSchedulableFromTrail(trail), selected.map(SchedulableService.getSchedulableFromTrail))) {
                // If there's not a conflict, see what schedules exist for the other sets with this trail selected
                // TODO: when we select this trail, we need to remove all other sets that have the same type and id (excluding the root of the sets)
                // for every layer of this trail
                return SchedulableService.generateSchedule(selected.concat([trail]), sets.slice(1)).map((schedule) => [...schedule, trail]); // Add the current trail to all of these schedules.
            }
            // If this trail has a conflict with what's selected we return an empty list, the list of schedules that are valid for this trail -- none.
            return [];
        }));
    }
}
